// const baseUrlLocal = "http://localhost:5001";

const baseUrl = process.env.REACT_APP_API_URL;
export default baseUrl;
